import React, { useState, useEffect } from 'react';
import '../style.css';

const JourneySection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // High-quality taxi images
  const bannerImages = [
    'image2.png',
    'image1.png',
    'image3.png',
    'image2.png'
  ];

  // Auto slide every 5 seconds
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === bannerImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(slideInterval);
  }, [bannerImages.length]);

  // Preload all images
  useEffect(() => {
    bannerImages.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className="fullscreen-banner">
      {/* Background Images */}
      <div className="banner-backgrounds">
        {bannerImages.map((image, index) => (
          <div
            key={index}
            className={`background-layer ${index === currentIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
      </div>


      {/* Mobile Indicators Only */}
      <div className="mobile-indicators">
        {bannerImages.map((_, index) => (
          <div
            key={index}
            className={`indicator-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default JourneySection;